(function () {
  if (window.__AG_PB_ENV_TABS_INIT__) return;
  window.__AG_PB_ENV_TABS_INIT__ = true;

  var TAB_MS = 260;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getTabs(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.js-ag-pb-env-tab'));
  }

  function getPanels(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.js-ag-pb-env-panel'));
  }

  function showPanel(panel) {
    if (!panel) return;
    panel.removeAttribute('hidden');
    panel.classList.add('is-active');
  }

  function hidePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-active', 'is-entering', 'is-exiting');
    panel.setAttribute('hidden', '');
  }

  function activateTab(root, tab) {
    var tabs = getTabs(root);
    var panels = getPanels(root);
    if (!tab || tabs.length === 0) return;
    if (root._agEnvTabBusy) return;
    if (tab.classList.contains('is-active')) return;

    root._agEnvTabBusy = true;

    tabs.forEach(function (btn) {
      var active = btn === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      btn.tabIndex = active ? 0 : -1;
    });

    var panelId = tab.getAttribute('aria-controls');
    var next = panels.find(function (panel) {
      return panel.id === panelId;
    });
    var current = panels.find(function (panel) {
      return panel.classList.contains('is-active') && !panel.classList.contains('is-exiting');
    });

    if (!next || current === next) {
      root._agEnvTabBusy = false;
      return;
    }

    function enterNext() {
      if (current) hidePanel(current);
      showPanel(next);

      if (prefersReducedMotion()) {
        root._agEnvTabBusy = false;
        return;
      }

      next.classList.add('is-entering');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          next.classList.remove('is-entering');
          window.setTimeout(function () {
            root._agEnvTabBusy = false;
          }, TAB_MS);
        });
      });
    }

    if (!current || prefersReducedMotion()) {
      enterNext();
      return;
    }

    current.classList.add('is-exiting');
    current.classList.remove('is-active');
    window.setTimeout(enterNext, TAB_MS);
  }

  function buildTabs(root) {
    var tablist = root.querySelector('.js-ag-pb-env-tablist');
    var panels = getPanels(root);
    if (!tablist || panels.length === 0) return;

    tablist.innerHTML = '';

    panels.forEach(function (panel, index) {
      var label = panel.getAttribute('data-tab-label') || ('Tab ' + (index + 1));
      var panelId = panel.id;
      var tabId = panelId + '-tab';
      var isFirst = index === 0;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ag-pb-env-tabs__tab js-ag-pb-env-tab' + (isFirst ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      btn.id = tabId;
      btn.setAttribute('aria-selected', isFirst ? 'true' : 'false');
      btn.setAttribute('aria-controls', panelId);
      btn.tabIndex = isFirst ? 0 : -1;
      btn.textContent = label;

      panel.setAttribute('aria-labelledby', tabId);
      if (isFirst) {
        showPanel(panel);
      } else {
        hidePanel(panel);
      }

      tablist.appendChild(btn);
    });
  }

  function onKeydown(root, event) {
    var tabs = getTabs(root);
    if (tabs.length === 0) return;
    var currentIndex = tabs.indexOf(document.activeElement);
    if (currentIndex < 0) return;

    var nextIndex = currentIndex;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    tabs[nextIndex].focus();
    activateTab(root, tabs[nextIndex]);
  }

  function initRoot(root) {
    if (!root || root._agEnvTabsReady) return;
    root._agEnvTabsReady = true;

    buildTabs(root);
    root.classList.add('is-ready');

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('.js-ag-pb-env-tab');
      if (!tab || !root.contains(tab)) return;
      activateTab(root, tab);
    });

    root.addEventListener('keydown', function (event) {
      if (!event.target.closest('.js-ag-pb-env-tab')) return;
      onKeydown(root, event);
    });
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-env-tabs').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest('.js-ag-pb-env-panel');
    if (!panel) return;
    var root = panel.closest('.js-ag-pb-env-tabs');
    if (!root) return;
    if (!root._agEnvTabsReady) initRoot(root);
    var tabId = panel.getAttribute('aria-labelledby');
    var tab = tabId ? document.getElementById(tabId) : null;
    if (tab) activateTab(root, tab);
  });
})();
